export default __webpack_public_path__ + "static/media/1.9d1c333e.jpg";